import { MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane } from 'mdb-react-ui-kit'
import React, { useEffect, useState } from 'react'
import { getCarreras } from '../../../services/hipodromo';
import { ResponseProximasCarrerasIds } from '../../../interfaces/priximas_carreras.interface';
import Loading from '../../../componetes/loading';

import moment from 'moment';

import TabCarrerasCharts from './tabcarrerascharts';
const TabFechasCharts: React.FC = () =>{
    const [ list, setList] = useState<ResponseProximasCarrerasIds[]>([])
    // const [fechas, setFechas] = useState<string[]>([])
    const [fillActive, setFillActive] = useState<string>('');
    const handleFillClick = (value: string) => {
        if (value === fillActive) {
          return;
        }
        setFillActive(value);
      };
    
    useEffect(()=>{
        const ids = async () =>{
            setList(await getCarreras())
        }
        ids()
    // eslint-disable-next-line
    }, [fillActive])
    return<>
    <MDBTabs className='mb-3'>
        
            {
                list ?
                list.map((value, index)=>{
                    const fecha = value.fecha
                    return(<>
                    <MDBTabsItem>     
                        <MDBTabsLink key={index} onClick={() => handleFillClick(fecha)} active={fillActive === fecha}>
                            {
                                moment(moment(fecha, "YYYY-MM-DDTHH:mmZ").utc()).format('DD-MM-YYYY')
                               
                            }
                        </MDBTabsLink>
                    </MDBTabsItem>
                </>
            ) 
            } 
            )
            : <><Loading/></>
            }
        
    </MDBTabs>
    <MDBTabsContent>
    {
        list ?
            list.map((value, index)=>{
                
                const fecha = value.fecha
                if(fillActive){
                    return(<>
                    <MDBTabsPane key={index} open={fillActive === fecha}>
                        <TabCarrerasCharts ids={value.ids}/>
                    </MDBTabsPane></>)
                }else{
                    return <></>
                }
            }
    )
    : <></>
    }

    </MDBTabsContent>
    
    </>
}

export default TabFechasCharts